"use strict";

const isStartOfSnapUnit = require("../utils/is-start-of-snap-unit");

/**
 * Snap dates forward to snapDates time-unit.
 * Never snap when snapDates=false, or when there is a rolling end-date (future time will be invalid).
 */
const getSnappedEndDate = (result, props) => {
  const { endDate } = result;
  const { mode, snapDates } = props;

  if (!snapDates || ["since", "rolling"].includes(mode)) {
    return result;
  }

  if (!isStartOfSnapUnit(endDate, snapDates) || mode === "single") {
    return {
      ...result,
      endDate: endDate
        .plus({
          [`${snapDates}s`]: 1
        })
        .startOf(snapDates)
    };
  }

  return result;
};

module.exports = getSnappedEndDate;
